module.exports = __webpack_public_path__ + "static/media/Coverpage-shristi-ko-fool.1c6758bc.png";